module.exports = __webpack_public_path__ + "img/modal_ribbon_finish.2c7821a7.svg";